import linkedin from '../../../assets/social-media/linkedin.svg';
import youtube from '../../../assets/social-media/youtube.svg';
import twitter from '../../../assets/social-media/twitter.svg';
import instagram from '../../../assets/social-media/instagram.svg';
import facebook from '../../../assets/social-media/facebook.svg';

const icons = [
  {
    name: 'linkedin',
    link: 'https://www.linkedin.com/company/feller-ag/',
    icon: linkedin,
  },
  {
    name: 'youtube',
    link: 'https://www.youtube.com/channel/UCcrBkHSuMiQEfUKRunfvUAA',
    icon: youtube,
  },
  {
    name: 'instagram',
    link: 'https://www.instagram.com/feller.ag/',
    icon: instagram,
  },
  {
    name: 'facebook',
    link: 'https://www.facebook.com/FellerAG/',
    icon: facebook,
  },
  {
    name: 'twitter',
    link: 'https://twitter.com/fellerag',
    icon: twitter,
  },
];

export default icons;
